// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useEffect, useState } from "react";

const regex = {
    digit: /(?=.*\d)/g,
    lowerCase: /(?=.*[a-z])/g,
    upperCase: /(?=.*[A-Z])/g,
    nonAlphaNumaric: /(?=.*[-+_!@#$%^&*.,?])/g,
};

const validatePasswordRequirements = (
    password: string,
    passwordMinLength: number,
    checkDigits: boolean,
    checkLowerCase: boolean,
    checkUpperCase: boolean,
    checkNonAlphaNumarics: boolean,
) => {
    const [hasLowerCase, setHasLowerCase] = useState(false);
    const [hasUpperCase, setHasUpperCase] = useState(false);
    const [hasNonAlphanumaric, setHasNonAlphanumaric] = useState(false);
    const [hasDigit, setHasDigit] = useState(false);
    const [hasMoreThanEightCharachters, setHasMoreThanEightCharachters] = useState(false);

    useEffect(() => {
        if (password) {
            setHasMoreThanEightCharachters(password?.length >= passwordMinLength);
            setHasDigit(checkDigits ? regex.digit.test(password) : true);
            setHasLowerCase(checkLowerCase ? regex.lowerCase.test(password) : true);
            setHasUpperCase(checkUpperCase ? regex.upperCase.test(password) : true);
            setHasNonAlphanumaric(checkNonAlphaNumarics ? regex.nonAlphaNumaric.test(password) : true);
        }
    }, [password]);

    return {
        hasLowerCase,
        hasUpperCase,
        hasNonAlphanumaric,
        hasDigit,
        hasMoreThanEightCharachters,
    };
};

export default validatePasswordRequirements;
